import { useContext, useEffect } from 'react';
import { NextPage } from 'next';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { LocalStorageKeys as StorageKeys } from 'types/localeStorage';
import { Routes } from 'types/routes';

import { GLOWNY_SPECJALISTA_DS_BEZPIECZENSTWA_SYSTEMOW_TELEINFORMATYCZNYCH_EXATEL } from 'consts/jobs';
import { isBrowser } from 'utils/browser';
import { withVariables } from 'utils/string';

import LocaleContext from 'components/context/Locale';
import Button from 'components/layout/Button';
import Head from 'components/layout/Head';
import LayoutDefault from 'components/modules/public/layouts/Default';

import SectionArticles from './sections/Articles';
import SectionJob from './sections/Job';
import SectionNewsletter from './sections/Newsletter';
import SectionOffers from './sections/Offers';
import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJob: NextPage<Props> = ({ job, jobCity, jobs, articles }) => {
    const { publicRuntimeConfig } = getConfig();

    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.job;
    let ogPhoto = jobCity?.ogPhoto?.imageUrl || job?.primaryCity?.ogPhoto?.imageUrl || null;

    useEffect(() => {
        const id = job?.id;
        const jobCityId = jobCity?.id || '';

        let visitedOffers = JSON.parse(localStorage.getItem(StorageKeys.VisitedOffers));
        visitedOffers = visitedOffers
            ? Array.from(visitedOffers)
            : [];

        const jobOfferLocalStorageId = id + jobCityId;
        visitedOffers.push(jobOfferLocalStorageId);
        const newOffersUnique = new Set([...visitedOffers]);
        localStorage.setItem(StorageKeys.VisitedOffers, JSON.stringify(Array.from(newOffersUnique)));
    }, []);

    if (job?.id === GLOWNY_SPECJALISTA_DS_BEZPIECZENSTWA_SYSTEMOW_TELEINFORMATYCZNYCH_EXATEL)
        ogPhoto = `${publicRuntimeConfig.APP_URL}/images/job/ogPhoto/${job?.id}.png`;
    const router = useRouter();
    const baseUrl = isBrowser() && router.query?.baseUrl ? window.atob(router.query.baseUrl.toString()) : null;
    const breadcrumbs = [
        {
            name: data?.content?.breadcrumbs?.home,
            path: Routes.PublicHome,
        },
        {
            name: data?.content?.breadcrumbs?.jobs,
            path: Routes.PublicJobs,
        },
        {
            name: job?.name,
            path: job?.slug,
        },
    ];
    return (
        <StyledComponent className={classnames(
            'public-page-job',
            { 'closed' : job?.isClosed }
        )}
        >
            <Head
                {...data.meta}
                title={job?.name}
                canonical={withVariables(Routes.PublicJob, { slug: job?.slug }, { jobCitySlug: jobCity?.id })}
                image={ogPhoto}
            />
            <LayoutDefault>
                {job?.isClosed && (
                    <div className="header-closed--mobile">
                        <div className="header-closed__container">
                            {/* <Button
                            {...data?.content?.jobCopy?.headerMobileClosed?.buttonProps?.back}
                            onClick={() => router.push(baseUrl || Routes.PublicJobs)}
                        /> */}
                            <div
                                className="title"
                                dangerouslySetInnerHTML={{ __html: data?.content?.jobCopy?.headerMobileClosed?.title }}
                            />
                        </div>
                    </div>
                )}
                {job?.isClosed && (
                    <SectionOffers
                        jobs={jobs}
                        {...data.content.closedOffers}
                    />
                )}
                <SectionJob
                    {...data?.content?.jobCopy}
                    job={job}
                    jobCity={jobCity}
                    breadcrumbs={breadcrumbs}
                />
                {!job?.isClosed && (
                    <SectionOffers
                        jobs={jobs}
                        {...data.content.offers}
                    />
                )}
                <SectionArticles
                    articles={articles}
                    {...data.content.articles}
                />
                <SectionNewsletter {...data.content.newsletter} />
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageJob;
